import React, { useEffect, useRef } from 'react';

const Html = ({ children, className = '' }) => {
  const ref = useRef();

  useEffect(() => {
    ref.current.innerHTML = children;

    ref.current.querySelectorAll('table').forEach((tbl) => {
      const wrapper = document.createElement('div');

      wrapper.style.wordBreak = 'keep-all';
      wrapper.className = 'table-responsive';
      tbl.parentNode.replaceChild(wrapper, tbl);
      wrapper.appendChild(tbl);
    });
  }, [children]);

  return (
    <div
      className={`note-content ${className}`}
      ref={ref}
    ></div>
  );
};

export default Html;
